import React from 'react';

export const steps = [
  {
    selector: '[data-tour="step-0"]',
    content: (
      <p>
        Seja bem-vindo(a) à nova Área do Participante! Como é o seu primeiro
        acesso, siga os passos para conhecer um pouco da nova navegação.
      </p>
    ),
  },
  {
    selector: '[data-tour="step-1"]',
    content: (
      <p>
        Aqui é possível visualizar o seu plano de benefícios e realizar buscas.
        Caso possua mais de um plano é possível selecionar qual você deseja
        visualizar as informações.
      </p>
    ),
  },
  {
    selector: '[data-tour="step-2"]',
    content: (
      <p>
        Este é o menu principal, onde você poderá navegar entre diferentes
        funcionalidades. Passando o mouse no ícone é possível ver o que cada
        botão representa.
      </p>
    ),
  },
  {
    selector: '[data-tour="step-3"]',
    content: (
      <p>
        Esta é a página inicial da sua área logada. Nela, é possível visualizar
        quadros com diferentes tópicos, facilitando a busca de informações.
      </p>
    ),
  },
  {
    selector: '[data-tour="step-4"]',
    content: (
      <p>
        Para facilitar ainda mais, você pode personalizar os quadros,
        selecionando quais informações deseja ver na sua página inicial assim
        que realizar o login na Área do Participante.
      </p>
    ),
  },
  {
    selector: '[data-tour="step-5"]',
    content: (
      <p>
        Chegamos ao final do tour. Em caso de dúvidas, entre em contato com a
        Forluz pelo Fale Conosco. E aproveite a nova Área do Participante!
      </p>
    ),
  },
];
